export const Messages = {
  ADD_SUCCESS: "{item} was saved successfully",
  ADD_SUCCESS_APPLICATION: "{item} was submitted successfully",
  ADD_SUCCESS_ACCOUNT:
    "{item} created successfully. An email has been sent to your email address, please check your inbox/spam folder for further instructions",
  ADD_FAILURE: "Oops system failed to save {item}, please try again later",
  ADD_FAILURE_DUPLICATE:
    "{item} record already exists, you can update the record",
  ADD_SUCCESS_DOC: "{item} were saved successfully",
  ADD_FAILURE_DOC: "Oops system failed to save {item}, please try again later",
  DELETE_SUCCESS: "{item} deletion was successful",
  DELETE_FAILURE: "Oops system failed to delete {item}, please try again later",
  DISABLE_SUCCESS: "{item} was successful",
  DISABLE_FAILURE:
    "Oops system failed to disable {item}, please try again later",
  GET_SUCCESS: "{item} was retrieved successfully",
  GET_FAILURE: "Oops system failed to retrieve {item}, please try again",

  UPDATE: "{item} withdrawal was successfully",
  UPDATE_STATUS: "{item} was {status} successfully",
  UPDATE_STATUS_ASSIGN: "{item} was assigned successfully",
  GENERIC_ACTION_SUCCESS: "{item} was {item} successfully",
  UPDATE_FAILURE_STATUS: "Oops system failed to update {item}, please try again",
  UPDATE_SUCCESS: "{item} was updated successfully",
  UPDATE_SUCCESSWITHOK:
    "{item} was updated successfully" +
    "\n" +
    "but your changes will only take effect on your next login",
  UPDATE_FAILURE: "Oops system failed to update {item}, please try again",
  UPDATE_CANCELLED: "",
  EXIST_UPDATE_FAILURE:
    "Oops system failed to update {item}, record already exist",
  EXIST_ADD_FAILURE: "Oops system failed to add {item}, record already exist",
  SERVER_REQUEST_FAILURE: "Server failed to process your request, please try again later",
  USER_REQUEST_FAILURE: "Something is incorrect with front-end input",
  USER_EXISTS: "Provided email is already in use, Please use a different email",
  EMAIL_SEND_SUCCESS: "Email was sent successfully to {item}",
  EMAIL_SEND_FAILURE: "Oops! system failed to send email to {item}",
  INVALID_EMAIL_DOMAIN: "Email syntax or domain is invalid",
  INVALID_TOKEN_EXPIRES: "Unauthorised, invalid or expired token",
  UNAUTHORISED: "Unauthorised access, due to user rights",
  AGE_LIMIT_EXCEEDED:
    "Your age is above the NYS programme age limit of 35, you're not eligible to apply",
  WITHDRAWAL: "{item} withdrawal was successfully",
  FILE_UPLOAD_NO_FILE: "Oops no file was selected for upload",
  FILEUPLOAD_SUCCESS: "{item} was uploaded successfully",
  FILEUPLOAD_FAILURE:
    "Oops system failed to upload {item}, please try again later",
  FILEUPLOAD_FAILURE_SIZE:
    "System failed to upload {item}, file records seem to exceeds the limit of 100K records/rows",
  FILEDOWNLOAD_SUCCESS: "{item} was downloaded successfully",
  FILEDOWNLOAD_FAILURE:
    "Oops system failed to download {item}, please try again later",
  LOG_FAILURE: "Oops system failed to retrieve {item}, please try again later",
  NO_DATA: "No data was retrieved for {item}",
  CONFLICT: "Error: {item} already exists in the system",
  NOT_EXIST_FOR_INSERT: "{item} does not exist, it may be inserted",
  CLOSING_DATE: "System failed to retrieve closing date",
  SUCCESS: "{item} was successful",
  FAILURE: "Oops {item} failed, please try again later",
  PUBLIC_USER_EXISTS:
    "Provided email is already in use, please reset your password to proceed",
  DATE_ERROR: "{item}  Please enter correct date",
  INVALID_SELECTION: "Please note that only {item} can be selected",

  JOIN_SUCCESS:
    "Thank you for submitting your details. Please check your email for a confirmation message",
  JOIN_FAILURE: "Oops system failed to submit {item}, please try again later",
  INVALID_CAPTCHA: "Captcha provided is invalid, please try again",
  CLOSE_SUCCESS: "{item} was closed successfully",
  INVALID_FIELD: "One of the fields are invalid",

  REJECTION_FAILED: "Oops system failed to complete rejection process for candidate",
  REJECTION_SUCCESS: "Candaidate was rejected successfully",
  REJECTION_EXISTS: "Candadate is already rejected",
};

export const Notify = Object.freeze({
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
  WARNING: "warning",
  DESTROY: "destroy",
});
